module.exports = __webpack_public_path__ + "img/FR15128.69bfb1ec.png";